const BuildTypes = {
    FULL: 'FULL_SGE',
    PROD: 'production'
};

export default BuildTypes;



// WEBPACK FOOTER //
// src/utils/BuildTypes.js